<template>
  <f7-page
    no-toolbar
    no-navbar
    no-swipeback
  >
    <div
      class="mt-20 mx-10 sm:ml-20"
    >
      <div
        class="sm:flex justify-around"
      >
        <img
          class="order-1 self-start"
          src="@/assets/guide.svg"
          alt="billing"
        >
        <div>
          <div
            class="font-bold text-xl mt-5"
          >
            ¡Cuéntales que los estás cuidando!
          </div>
          <div
            class="text-xl max-w-md mt-6"
          >
            <div>
              Enviamos una plantilla de correo electrónico de invitación a <b>{{ billingEmail }}</b>.
            </div>
            <div>
              Reenvíalo a las personas que cuidas para que sepan
            </div>
            <div
              class="bg-blue-500 w-64 text-white flex leading-8 px-2 py-1 rounded-md my-2"
            >
              <eva-icon
                class="mt-1 text-center"
                name="corner-up-right-outline"
                fill="#FFFFFF"
              />
              <div>
                Reenvíame el correo
              </div>
            </div>
          </div>
          <div
            class="text-xl mt-20"
          >
            <div>
              También puedes compartir la información por redes sociales.
            </div>
            <div
              class="bg-blue-500 w-64 text-white flex leading-8 px-2 py-1 rounded-md my-2"
            >
              <eva-icon
                class="mt-1"
                name="share-outline"
                fill="#FFFFFF"
              />
              <div class="text-center w-full">
                Compartir
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'Template',
  components: {
  },
  data () {
    return {
      billingEmail: 'g@isaga.co',
    }
  },
  computed: {
    ...mapState({
    }),
  },
  watch: {
  },
  async mounted () {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
</style>
